import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/");
  }, [user, loading, navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0A0A0A]">
      <div className="hidden lg:block relative">
        <img
          src="https://customer-assets-39nsmqrw.emergentagent.net/job_bike-service-central-1/artifacts/wrospck1_WhatsApp%20Image%202026-07-18%20at%2011.42.49%20%281%29.jpeg"
          alt="Escursione e-MTB Bicimone" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/40 to-transparent" />
        <div className="absolute bottom-10 left-10">
          <div className="font-display text-6xl tracking-tight leading-none">BICIMON-E</div>
          <div className="text-zinc-300 mt-2 max-w-sm">Officina · Gestione flotta e-MTB · manutenzioni · ricambi · QR</div>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center px-8 py-16 fade-in">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-3 mb-10">
            <div className="bg-white rounded-sm p-3 inline-flex">
              <img src="/bicimone-logo.jpg" alt="Bicimone" className="h-10" />
            </div>
          </div>

          <h1 className="font-display text-4xl tracking-tight mb-2">ACCEDI</h1>
          <p className="text-zinc-400 text-sm mb-8">
            Entra con il tuo account Google. Il primo utente diventa Super Admin, gli altri vengono approvati da un amministratore.
          </p>

          <button onClick={handleLogin} data-testid="google-login-btn"
            className="w-full flex items-center justify-center gap-3 bg-white text-[#0A0A0A] font-semibold rounded-sm px-6 py-3.5 hover:bg-zinc-200 transition-colors active:scale-[0.98]">
            <svg className="h-5 w-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continua con Google
          </button>

          <p className="text-zinc-600 text-xs mt-6 text-center">Accesso riservato. Solo via Google OAuth.</p>
        </div>
      </div>
    </div>
  );
}
